const defaultState = () => ({
    credentialsFormSubmitPending: false,
    fetchGcpProjectPending: false,
    credentialsError: null,
    gcpProjects: null
});

export default (state = defaultState(), {payload, type}) => {
    switch (type) {
        case "CVS2:SUBMIT-CREDENTIALS": {
            return { ...state, credentialsFormSubmitPending: true, credentialsError: null }
        }
        case "CVS2:SUBMIT-CREDENTIALS-SUCCESS": {
            return { ...state, credentialsFormSubmitPending: false, credentialsError: null }
        }
        case "CVS2:SUBMIT-CREDENTIALS-FAILURE": {
            const { credentialsError } = payload;
            return { ...state, credentialsFormSubmitPending: false, credentialsError }
        }
        case "CVS2:FETCH-GCP-PROJECTS": {
            return { ...state, fetchGcpProjectPending: true, credentialsError: null }
        }
        case "CVS2:FETCH-GCP-PROJECTS-SUCCESS": {
            const { gcpProjects } = payload;
            return { ...state, fetchGcpProjectPending: false, credentialsError: null, gcpProjects }
        }
        case "CVS2:FETCH-GCP-PROJECTS-FAILURE": {
            const { credentialsError } = payload;
            return { ...state, fetchGcpProjectPending: false, credentialsError }
        }
    }
    return state;
};
